module.exports = __webpack_public_path__ + "static/img/分割背景@2x.043058fa.png";